import { deleteDoc, deleteField, getDocs, limit, orderBy, query, serverTimestamp, setDoc, updateDoc, where, } from "firebase/firestore";
import { asNoteId, asUserId, between, err, jitter, newId, ok, } from "@pack-it-up/shared";
import { toDomainNote, toNoteDto } from "../mappers/index.js";
import { observeQuery, toDomainError } from "./support.js";
export const makeNoteRepo = (db, p) => {
    // Prepend order = a fractional index just before the current first note in the
    // list, so a new note lands at the top of manual order — same spot the old
    // newest-first sort always put it. Same jittered pattern as item.repo.ts /
    // category.repo.ts (see there for why no transaction is needed), mirrored around
    // the front of the list instead of the back.
    const prependOrder = async (listId) => {
        const snap = await getDocs(query(p.notes(), where("listId", "==", listId), orderBy("order", "asc"), limit(1)));
        const first = snap.docs[0]?.get("order");
        return jitter(between(null, (first ?? null)));
    };
    return {
        observeNotes: (listId) => observeQuery(query(p.notes(), where("listId", "==", listId)), toDomainNote, "notes"),
        async upsertNote(note) {
            try {
                if (note.id === undefined) {
                    const id = newId();
                    const domain = {
                        id: asNoteId(id),
                        listId: note.listId,
                        body: note.body,
                        links: note.links,
                        ...(note.tags !== undefined && note.tags.length > 0 ? { tags: note.tags } : {}),
                        authorId: asUserId(note.authorId),
                        createdAt: 0,
                        order: await prependOrder(note.listId),
                    };
                    await setDoc(p.note(id), { ...toNoteDto(domain), createdAt: serverTimestamp() });
                    return ok(asNoteId(id));
                }
                // Update: only overwrite body/links/tags; preserve authorId, createdAt and order.
                // `tags` is absent from the DTO when the note has none, and updateDoc throws
                // on `undefined`, so an emptied tag list clears the stored field instead.
                await updateDoc(p.note(note.id), {
                    body: note.body,
                    links: note.links,
                    tags: note.tags !== undefined && note.tags.length > 0 ? note.tags : deleteField(),
                });
                return ok(note.id);
            }
            catch (e) {
                return err(toDomainError(e));
            }
        },
        async deleteNote(noteId) {
            try {
                await deleteDoc(p.note(noteId));
                return ok(undefined);
            }
            catch (e) {
                return err(toDomainError(e));
            }
        },
        async moveNote(noteId, order) {
            try {
                await updateDoc(p.note(noteId), { order });
                return ok(undefined);
            }
            catch (e) {
                return err(toDomainError(e));
            }
        },
    };
};
//# sourceMappingURL=note.repo.js.map